import { z } from 'zod';
import { ACCOUNT_TYPE_VALUES } from '../../molecules/AccountTypeToggleGroup/AccountTypeToggleGroup.types';
import { VISIBILITY_VALUES } from '../../molecules/VisibilityToggleGroup/VisibilityToggleGroup.types';

export const LIST_NAME_MAX_LENGTH = 60;

export const favoriteListModalFormSchema = z.object({
  listName: z.string().trim().min(1).max(LIST_NAME_MAX_LENGTH),
  visibility: z.enum(VISIBILITY_VALUES),
  accountType: z.enum(ACCOUNT_TYPE_VALUES).optional(),
});
